import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { getFacility } from 'src/app/state/selectors';
import { useSelector } from 'src/app/state/store';

export interface PhoneNumberProps {
  className?: string;
}

export const PhoneNumber = ({ className }: PhoneNumberProps) => {
  const dispatchClickAnalyticsEvent = useSegmentEvent('contactUsCallOrText', { shouldTrackOnMount: false });
  const facility = useSelector(getFacility);

  return (
    <a
      className={className}
      href={`tel:${facility?.phone}`}
      onClick={() => dispatchClickAnalyticsEvent({ openedFrom: window?.location?.pathname })}
    >
      {facility?.phone}
    </a>
  );
};
